// extracted by mini-css-extract-plugin
export default {"main_div":"Plan_main_div__mHaOG","form_div":"Plan_form_div__SGVHY"};